import MicroModal from 'micromodal';

import {trapFocus, removeTrapFocus} from '../vendor/theme-scripts/theme-a11y';
import Media from '../media/media';
import FetchError from '../util/fetch-error';

import {ProductAddForm} from './product-form';
import {Popout} from './popout';
import {Swatch} from './swatch';

const classes = {
  open: 'is-open',
};

const selectors = {
  upsellHolder: 'data-upsell-holder',
  addButtonWrapper: '[data-add-action-wrapper]',
  upsellModal: '[data-upsell-modal]',
  modalContainer: '[data-product-upsell-container]',
  modalContent: '[data-product-upsell-ajax]',
  upsellModalTemplate: '[data-upsell-modal-template]',
  apiContent: '[data-api-content]',
  media: '[data-media-slide]',
  cartLineItems: '[data-line-items]',
  focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
  popoutWrapper: '[data-popout]',
  swatch: '[data-swatch]',
};

class UpsellProduct extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.upsellHolder = this.container.querySelector(`[${selectors.upsellHolder}]`);

    if (this.upsellHolder) {
      this.html = document.documentElement;
      this.isCartItem = Boolean(this.upsellHolder.closest(selectors.cartLineItems));
      this.modalTemplate = this.upsellHolder.querySelector(selectors.upsellModalTemplate);
      this.modal = document.querySelector(selectors.upsellModal);
      this.modalID = this.upsellHolder.getAttribute(selectors.upsellHolder);
      this.triggerButton = this.upsellHolder.querySelector(`[data-popup-${this.modalID}]`);
      this.handle = this.triggerButton ? this.triggerButton.getAttribute(`data-popup-${this.modalID}`) : null;

      this.modalContainer = null;
      this.modalContent = null;

      if (this.modalTemplate && !this.modal) {
        const modalTemplateInner = this.modalTemplate.innerHTML;
        const htmlObject = document.createElement('div');
        htmlObject.innerHTML = modalTemplateInner;
        const modalHtml = htmlObject.querySelector(selectors.upsellModal);
        document.body.appendChild(modalHtml);
        this.modal = document.querySelector(selectors.upsellModal);
      }

      this.init();
    }
  }

  init() {
    if (this.modalTemplate && this.triggerButton) {
      this.triggerButton.addEventListener('click', (e) => {
        e.preventDefault();

        if (this.modal && this.modalID) {
          this.modal.id = this.modalID;
        }

        this.getUpsellHTML();
      });
    }

    document.addEventListener('theme:product:button-update', (e) => {
      if (e.detail.response.status || !this.modal.classList.contains(classes.open)) return;

      MicroModal.close(this.modalID);
    });
  }

  getUpsellHTML() {
    if (this.modalContent) {
      this.modalCreate();
    } else {
      window
        .fetch(`/products/${this.handle}?section_id=api-product-upsell`)
        .then(this.handleErrors)
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          const fresh = document.createElement('div');
          fresh.innerHTML = response;
          this.modalContent = document.querySelector(selectors.modalContent);
          this.modalContent.innerHTML = fresh.querySelector(selectors.apiContent).innerHTML;

          this.reInitFormFunctionalities();
          this.modalCreate();
        });
    }
  }

  reInitFormFunctionalities() {
    new ProductAddForm(null, this.modal);

    const swatchElements = this.modalContent.querySelectorAll(selectors.swatch);
    swatchElements.forEach((el) => {
      new Swatch(el);
    });

    const wrappers = this.modalContent.querySelectorAll(selectors.popoutWrapper);
    wrappers.forEach((wrapper) => {
      new Popout(wrapper);
    });
  }

  modalCreate() {
    this.modalContainer = document.querySelector(selectors.modalContainer);

    MicroModal.show(this.modalID, {
      onShow: (modal, el, event) => {
        const mediaObject = {
          container: modal,
          id: this.modalID,
        };
        theme.mediaInstances[this.id] = new Media(mediaObject);
        theme.mediaInstances[this.id].init();

        const firstFocus = modal.querySelector(selectors.focusable);
        trapFocus(modal, {elementToFocus: firstFocus});

        document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: this.modalContainer}));
      },
      onClose: (modal, el, event) => {
        const allMedia = modal.querySelectorAll(selectors.media);

        allMedia.forEach((media) => {
          media.dispatchEvent(new CustomEvent('pause'));
        });

        removeTrapFocus();
        el.focus();
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
      },
    });
  }

  handleErrors(response) {
    if (!response.ok) {
      return response.json().then(function (json) {
        const e = new FetchError({
          status: response.statusText,
          headers: response.headers,
          json: json,
        });
        throw e;
      });
    }
    return response;
  }
}

export {UpsellProduct};
